export default {
  'form.stepform.basic.title': '分步表单',
  'form.stepform.basic.description':
    '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',

  'form.stepform.email.required': '请输入邮箱地址！',
  'form.stepform.email.wrong-format': '邮箱地址格式错误！',
  'form.stepform.userName.required': '请输入用户名!',
  'form.stepform.password.required': '请输入密码！',
  'form.stepform.password.twice': '两次输入的密码不匹配!',
  'form.stepform.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'form.stepform.strength.strong': '强度：强',
  'form.stepform.strength.medium': '强度：中',
  'form.stepform.strength.short': '强度：太短',
  'form.stepform.confirm-password.required': '请确认密码！',
  'form.stepform.phone-number.required': '请输入手机号！',
  'form.stepform.phone-number.wrong-format': '手机号格式错误！',
  'form.stepform.verification-code.required': '请输入验证码！',
  'form.stepform.title.required': '请输入标题',
  'form.stepform.date.required': '请选择起止日期',
  'form.stepform.goal.required': '请输入目标描述',
  'form.stepform.standard.required': '请输入衡量标准',

  'form.stepform.form.get-captcha': '获取验证码',
  'form.stepform.captcha.second': '秒',
  'form.stepform.form.optional': '（选填）',
  'form.stepform.form.submit': '提交',
  'form.stepform.form.save': '保存',
  'form.stepform.email.placeholder': '邮箱',
  'form.stepform.password.placeholder': '至少6位密码，区分大小写',
  'form.stepform.confirm-password.placeholder': '确认密码',
  'form.stepform.phone-number.placeholder': '手机号',
  'form.stepform.verification-code.placeholder': '验证码',
  'form.stepform.title.label': '标题',
  'form.stepform.title.placeholder': '给目标起个名字',
  'form.stepform.date.label': '起止日期',
  'form.stepform.placeholder.start': '开始日期',
  'form.stepform.placeholder.end': '结束日期',
  'form.stepform.goal.label': '目标描述',
  'form.stepform.goal.placeholder': '请输入你的阶段性工作目标',
  'form.stepform.standard.label': '衡量标准',
  'form.stepform.standard.placeholder': '请输入衡量标准',
  'form.stepform.client.label': '客户',
  'form.stepform.label.tooltip': '目标的服务对象',
  'form.stepform.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'form.stepform.invites.label': '邀评人',
  'form.stepform.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'form.stepform.weight.label': '权重',
  'form.stepform.weight.placeholder': '请输入',
  'form.stepform.public.label': '目标公开',
  'form.stepform.label.help': '客户、邀评人默认被分享',
  'form.stepform.radio.public': '公开',
  'form.stepform.radio.partially-public': '部分公开',
  'form.stepform.radio.private': '不公开',
  'form.stepform.publicUsers.placeholder': '公开给',
  'form.stepform.option.A': '同事甲',
  'form.stepform.option.B': '同事乙',
  'form.stepform.option.C': '同事丙',
};
